import React from 'react'
import Switch from 'react-bootstrap/esm/Switch'
import { Redirect, Route } from 'react-router-dom'
import { PublicBanDo } from './PublicBanDo'
import { PublicBaoCao } from './PublicBaoCao'
import { PublicSoLieu } from './PublicSoLieu'

export const Public = () => {
    return (
        <Switch>
            <Route exact path="/public/">
                <Redirect to="/public/bando"></Redirect>
            </Route>
            <Route path="/public/bando">
                <PublicBanDo></PublicBanDo>
            </Route>
            <Route path="/public/baocao">
                <PublicBaoCao></PublicBaoCao>
            </Route>
            <Route path="/public/solieu">
                <PublicSoLieu></PublicSoLieu>
            </Route>
        </Switch>
    )
}
